import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as utils from '../utils.js'

const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene()

const geometry = new THREE.BufferGeometry();
// create a simple square shape. We duplicate the top left and bottom right
// vertices because each vertex needs to appear once per triangle.
const vertices = [];

let separation = 0.1;


/*

4-----2/3
|     |
|     |
0/5---1
*/

function moveSquare(x,y,amount, vertices, positions)
{
if(x<0 || x>100 || y<0 || y>100)
{
    return;
}
let square = x * 18 + y * 100 * 18;
let yChange = utils.randomFloat(0,1);

for(let i=0; i<vertices.length;i++)
{
    positions[square+1+vertices[i]*3] += amount;
}
}

for(let j=-50; j<50; j++)
{
for(let i=-50;i<50;i++)
{
    vertices.push(i+separation,      0.0,    j+separation);
    vertices.push(i+1.0-separation,  0.0,    j+separation);
    vertices.push(i+1.0-separation,  0.0,    j+1.0-separation);
    
    vertices.push(i+1.0-separation,  0.0,    j+1.0-separation);
    vertices.push(i+separation,      0.0,    j+1.0-separation);
    vertices.push(i+separation,      0.0,    j+separation);
}
}

// itemSize = 3 because there are 3 values (components) per vertex
geometry.setAttribute(
"position",
new THREE.Float32BufferAttribute(vertices, 3)
);
const material = new THREE.MeshBasicMaterial({ color: 0xff0000, side: THREE.DoubleSide });
const mesh = new THREE.Mesh(geometry, material);
scene.add(mesh);

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 300)
camera.position.z = -75;
camera.position.y = 50;
camera.lookAt(0,0,0);
scene.add(camera)

const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    let randomX = utils.randomInteger(0,100);
    let randomY = utils.randomInteger(0,100);

    const positions = mesh.geometry.attributes.position.array;
    let yChange = utils.randomFloat(-1.0,1.0);
    moveSquare(randomX,randomY,yChange,[0,1,2,3,4,5],positions);

    moveSquare(randomX-1,randomY,yChange,[1,2,3],positions);
    moveSquare(randomX+1,randomY,yChange,[0,4,5],positions);
    moveSquare(randomX,randomY+1,yChange,[0,1,5],positions);
    moveSquare(randomX,randomY-1,yChange,[2,3,4],positions);

    moveSquare(randomX+1,randomY+1,yChange,[0,5],positions);
    moveSquare(randomX-1,randomY-1,yChange,[2,3],positions);
    moveSquare(randomX+1,randomY-1,yChange,[4],positions);
    moveSquare(randomX-1,randomY+1,yChange,[1],positions);
  
    mesh.geometry.attributes.position.needsUpdate = true;

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()